<template>
    <div>
        <base-dropdown class="nav-item nav-dropdown" v-if="this.$USER_LOGIN.get().isAdmin || this.$USER_LOGIN.get().isSuperadmin || this.$USER_LOGIN.get().isMaster">
            <a slot="title" class="nav-link" role="button">
                <i :class="'fas fa-wallet ' + (this.$THEME.primaryColor?'':'text-danger')" v-bind:style="{color: this.$THEME.primaryColor}"></i>
                <span class="nav-link-text">วอทเล็ท</span>
                <i class="fas fa-caret-down pl-2"></i>
            </a>
            <template v-if="this.$USER_LOGIN.get().isAdmin">
                <div class="dropdown-header">
                    <h6 class="text-overflow m-0">วอทเล็ท</h6>
                </div>
                <router-link 
                    v-if="$WALLET.status === true"
                    to="/topupcredit" 
                    class="dropdown-item" 
                >
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิต</span>
                </router-link>
                <router-link to="/history/topupwallet" class="dropdown-item">
                    <i class="fas fa-file-alt" v-bind:style="{color: this.$THEME.primaryColor}"></i>
                    <span>ประวัติเติมเครดิต</span>
                </router-link>
                <router-link to="/history/usagewallet" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งาน</span>
                </router-link>
            </template>
            <template v-if="this.$USER_LOGIN.get().isSuperadmin">
                <div class="dropdown-header">
                    <h6 class="text-overflow m-0">วอทเล็ทของฉัน</h6>
                </div>
                <!-- <router-link to="/notification/topupcredit" class="dropdown-item">
                    <Icon icon="mdi-account-cash" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>แจ้งชำระเติมเครดิต</span>
                </router-link> -->
                <a class="dropdown-item" :href="`${patmentUrl}/auth/signin`" target="_blank" v-if="patmentUrl">
                    <Icon icon="mdi-account-cash" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ตรวจสอบยอดเติมเครดิตของร้านค้า</span>
                </a>
                <router-link to="/history/usagewallet/superadmin" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งานเครดิต</span>
                </router-link>
                <router-link to="/withdraw/credit" class="dropdown-item">
                    <Icon icon="mdi-notebook-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการถอนเครดิต</span>
                </router-link>
                <div class="dropdown-divider"></div>
            </template>
            <template v-if="this.$USER_LOGIN.get().isSuperadmin || this.$USER_LOGIN.get().isMaster">
                <div class="dropdown-header">
                    <h6 class="text-overflow m-0">สาขาของฉัน</h6>
                </div>
                <router-link to="/topupcredit/shop" class="dropdown-item" v-if="this.$THEME.manageVision.menuTopUpCreditSA && this.$USER_LOGIN.get().isSuperadmin">
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิตให้สาขา</span>
                </router-link>
                <router-link to="/creditbalance/shop" class="dropdown-item" v-if="this.$USER_LOGIN.get().isSuperadmin">
                    <Icon icon="mdi-cash-100" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ยอดเครดิตคงเหลือของสาขา</span>
                </router-link>
                <router-link to="/history/topupcredit/superadmin" class="dropdown-item" v-if="this.$USER_LOGIN.get().isSuperadmin">
                    <Icon icon="mdi-file-document" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติเติมเครดิตของสาขา</span>
                </router-link>
                <router-link :to="{name: 'walletshops'}" class="dropdown-item">
                     <i
                        class="fas fa-chart-line"
                        v-bind:style="{ color: this.$THEME.primaryColor }"
                    ></i>
                    <span>ยอดรวมการใช้วอทเล็ทแต่ละสาขา</span>
                </router-link>
            </template>
        </base-dropdown>
    </div>
</template>

<script>
export default {
    name:"MenuWallet",
    data(){
        return{
            patmentUrl: process.env.VUE_APP_PAYMENT_URL || false
        }
    }
}
</script>
